/*
  Pinnacle Garage USA - hides old vehicles that nothing in the store fits from the Year / Make / Model finders
  (Shop by Vehicle bar, Shop For Your Vehicle sidebar, Wheels page finder, product page fit check).
  Loaded on every page from sections/pg-fitment-fill.liquid. The Wheel & Tire Size Guide is left as is.

  RULE  Years from PG_YMM_MIN onward, and every make / model under them, are never touched.
        An older year is shown only when at least one make / model in it is listed in PG_YMM_FITS,
        and then only those makes / models are shown.
  DATA  PG_YMM_FITS "Make|Model": "fromYear-toYear,year,..." = older years where at least one active product
        matches on the /collections/all?fit=1 results page. Regenerate with the browser script gen-avail.js
        (see its README) and paste its output over the PG_YMM_FITS block below.
*/
window.PG_YMM_MIN = 1990;
window.PG_YMM_FITS={"Acura|Integra":"1986-1989",
"BMW|3 Series":"1977-1989",
"BMW|5 Series":"1982-1989",
"BMW|6 Series":"1977-1989",
"BMW|7 Series":"1978-1989",
"Chevrolet|Beretta":"1987-1989",
"Chevrolet|Camaro":"1967-1989",
"Chevrolet|Cavalier":"1982-1989",
"Chevrolet|Corsica":"1987-1989",
"Chevrolet|Corvette":"1953-1989",
"Dodge|Challenger":"1970-1974,1978-1983",
"Dodge|Charger":"1966-1978,1983-1987",
"Dodge|Dart":"1960-1976",
"Dodge|Magnum":"1978-1979",
"GMC|Suburban":"1937-1989",
"Honda|Accord":"1976-1989",
"Honda|CR-X":"1984-1989",
"Honda|Civic":"1973-1987",
"Honda|Civic (EF / CRX)":"1988-1989",
"Honda|Prelude":"1979-1989",
"Hyundai|Excel":"1986-1989",
"Hyundai|Sonata":"1989",
"Jeep|Cherokee":"1974-1989",
"Jeep|Comanche":"1986-1989",
"Mazda|626":"1979-1989",
"Mazda|929":"1988-1989",
"Mazda|RX-7":"1979-1989",
"Mercedes-Benz|190 Series":"1984-1989",
"Mercedes-Benz|S-Class":"1973-1989",
"Mercedes-Benz|SL-Class":"1955-1989",
"Mercedes-Benz|SLC-Class":"1972-1981",
"Nissan|240SX":"1989",
"Nissan|300ZX":"1984-1989",
"Nissan|Maxima":"1989",
"Nissan|Pathfinder":"1987-1989",
"Nissan|Sentra":"1982-1989",
"Toyota|4Runner":"1984-1989",
"Toyota|Celica":"1971-1989",
"Toyota|Celica Supra / Supra / GR Supra":"1979-1989",
"Toyota|Corolla":"1968-1989",
"Toyota|Land Cruiser":"1958-1989",
"Toyota|MR2":"1985-1989",
"Toyota|Pickup / Hilux":"1969-1989",
"Volkswagen|Beetle / New Beetle":"1949-1979",
"Volkswagen|Golf":"1985-1989",
"Volkswagen|Golf GTI":"1985-1989",
"Volkswagen|Jetta":"1980-1989"};

(function () {
  var MIN = +window.PG_YMM_MIN || 1990, OK = {};
  /* OK[year][make][model] = 1 for every older year that has a fit */
  Object.keys(window.PG_YMM_FITS || {}).forEach(function (k) {
    var i = k.indexOf('|'), mk = k.slice(0, i), md = k.slice(i + 1);
    String(window.PG_YMM_FITS[k]).split(',').forEach(function (s) {
      var p = s.split('-'), a = +p[0], b = +(p[1] || p[0]);
      for (var y = a; y <= b && y < MIN; y++) { var Y = OK[y] = OK[y] || {}; (Y[mk] = Y[mk] || {})[md] = 1; }
    });
  });
  function allowed(y, mk, md) {
    if (!y || y >= MIN) return true;
    var Y = OK[y]; if (!Y) return false;
    if (mk == null) return true;
    if (!Y[mk]) return false;
    return md == null || !!Y[mk][md];
  }
  window.PG_YMM_OK = allowed;

  /* a saved vehicle that is no longer offered is forgotten, so no finder tries to restore it */
  try {
    var sv = JSON.parse(localStorage.getItem('pgVehicle') || 'null');
    if (sv && sv.y && !allowed(+sv.y, sv.mk, sv.model)) localStorage.removeItem('pgVehicle');
  } catch (e) {}

  /* [scope, year, make, model] selectors for each finder */
  var SETS = [
    ['.pg-ymm', 'select[data-role="year"]', 'select[data-role="make"]', 'select[data-role="model"]'],
    ['.pg-pfit, [data-pg-pfit]', 'select[data-pfit="y"]', 'select[data-pfit="mk"]', 'select[data-pfit="md"]'],
    ['.shopify-section, section, form', 'select[data-f="year"]', 'select[data-f="make"]', 'select[data-f="model"]']
  ];
  var ALL = SETS.map(function (s) { return s.slice(1).join(','); }).join(',');
  function txt(sel) { var o = sel && sel.options[sel.selectedIndex]; return o && o.value !== '' ? o.textContent.trim() : ''; }

  function prune(sel) {
    for (var i = 0; i < SETS.length; i++) {
      var S = SETS[i], role = sel.matches(S[1]) ? 0 : sel.matches(S[2]) ? 1 : sel.matches(S[3]) ? 2 : -1;
      if (role < 0) continue;
      var sc = sel.closest(S[0]); if (!sc) continue;
      var ys = sc.querySelector(S[1]), y = role ? parseInt(ys && ys.value, 10) || 0 : 0;
      if (role && (!y || y >= MIN)) return;
      var mk = role === 2 ? txt(sc.querySelector(S[2])) : null, lost = false;
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (o.value === '') return;
        var t = o.textContent.trim();
        var keep = role === 0 ? allowed(parseInt(o.value || t, 10) || 0) : role === 1 ? allowed(y, t) : allowed(y, mk, t);
        if (!keep) { if (o.selected) lost = true; o.remove(); }
      });
      if (lost) { sel.value = ''; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(ALL)) prune(root);
    Array.prototype.forEach.call(root.querySelectorAll(ALL), prune);
  }
  scan(document);
  new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var t = recs[i].target, s = t && t.closest ? (t.tagName === 'SELECT' ? t : t.closest('select')) : null;
      if (s && s.matches(ALL)) prune(s);
      var add = recs[i].addedNodes;
      for (var j = 0; j < add.length; j++) if (add[j].nodeType === 1 && add[j].tagName !== 'OPTION') scan(add[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { scan(document); });
})();